import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, CheckCircle2 } from 'lucide-react';
const contents = ["Explicación simple del 'ciclo 3am' (sin jerga)", 'Protocolo 10 (mañana): luz + movimiento + timing', 'Protocolo 3 (día): resets de 60–90 segundos', 'Protocolo 1 (noche): rutina corta + plan para despertares', 'Lista de sabotajes silenciosos (sin culpa, con micro-ajustes)', 'Plan de 21 días con métricas simples para ver progreso real', 'FAQ + glosario + recursos'];
export function WhatsIncluded() {
  return <section className="py-20 bg-[#fef3e2] px-4" data-id="element-198">
      <div className="max-w-4xl mx-auto" data-id="element-199">
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden" data-id="element-200">
          <div className="bg-[#0d9488] p-8 text-center" data-id="element-201">
            <h2 className="text-3xl font-bold text-white mb-2" data-id="element-202">
              ¿Qué incluye exactamente?
            </h2>
            <p className="text-teal-100 text-lg" data-id="element-203">
              Hormonas en Calma (45+) — PDF (Guía + ejercicios)
            </p>
          </div>

          <div className="p-8 md:p-12" data-id="element-204">
            <ul className="space-y-4" data-id="element-205">
              {contents.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start gap-3" data-id="element-206">
                  <CheckCircle2 className="w-6 h-6 text-[#0d9488] shrink-0 mt-0.5" data-id="element-207" />
                  <span className="text-lg text-slate-700" data-id="element-208">{item}</span>
                </motion.li>)}
            </ul>

            <div className="mt-10 pt-8 border-t border-slate-100 flex items-center justify-center gap-3 text-slate-500 italic" data-id="element-209">
              <BookOpen className="w-5 h-5" data-id="element-210" />
              <p data-id="element-211">
                Diseñado para: agendas reales, cansancio real, cero perfección.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}